import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1c147248 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/es",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/es-co",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-co"
  }, {
    path: "/es-es",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-es"
  }, {
    path: "/es-mx",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___es-mx"
  }, {
    path: "/fr",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr"
  }, {
    path: "/it",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___it"
  }, {
    path: "/ja",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___ja"
  }, {
    path: "/pt-br",
    component: _1c147248,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt-br"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
